import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { cleanedParams } from "../../plugins/utils";
import { SessionScheduleResponse } from "./data";
import { apiGetSessionSchedule } from "./service";

export const useGetSessionSchedule = (params: any, options: any) => {
  const queryKeyArr = [
    queryKey.SESSION_SCHEDULE,
    ...Object.values(cleanedParams(params)),
  ];
  return useQuery<SessionScheduleResponse[]>({
    queryKey: queryKeyArr,
    queryFn: () =>
      apiGetSessionSchedule(params).then(
        (res: ApiResponse<SessionScheduleResponse[]>) => res.data.data
      ),
    ...options,
  });
};
